import Call from '../Call';
import {objToQs} from '../Utils';

const AdkQuickFactor = {
    get(filters) {
        return Call(`adkQuickFactor?${objToQs(filters)}`);
    },

    getAll(filters) {
        return Call(`adkQuickFactor/all?${objToQs(filters)}`);
    },

    getAffid() {
        return Call(`adkQuickFactor/affid`);
    },

    getSubids(filters) {
        return Call(`adkQuickFactor/subid?${objToQs(filters)}`);
    },

    getSubidsAll(filters) {
        return Call(`adkQuickFactor/all/subid?${objToQs(filters)}`);
    }
}

export default AdkQuickFactor;


// WEBPACK FOOTER //
// ./src/services/API/components/AdkQuickFactor.js